module.exports = __webpack_public_path__ + "static/media/cover.bc5045ea.png";